import React, { useState } from "react";
import "./et_template.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
export default function EtTemplate(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);

  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: "Not Visited",
          notes: "Booking Visit",
          patient_id: patientId,
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <th style={style}>{value}</th>;
  };

  const handlesubmit = () => {
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "etReportGenerateWrap"
          ).innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "ET Template",
            },
          };

          // Dispatch action to create patient report
          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            // Swal.fire({
            //   title: "Successful.",
            //   text: "Record added successful.",
            //   icon: "success",
            //   showConfirmButton: false,
            //   timer: 1500,
            // });
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="EtTemplate">
      <div className="EtTemplate">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap:"3px"

            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formData.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formData.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formData.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.age1}
              </span>
            </div> */}

          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formData.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodGroup1}
              </span>
            </div> */}
          {/* </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <h3>ET Template</h3>
          <br />
          <br />
          <p>
            Plan FET on{" "}
            <input
              type="date"
              className={`createTime ${show ? "hide" : "show"}`}
              name="planfeton"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.planfeton}
            </span>
          </p>
          <p>
            Admission on{" "}
            <input
              type="date"
              className={`createTime ${show ? "hide" : "show"}`}
              name="admissionon"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.admissionon}
            </span>
          </p>
          <p>
            Condition{" "}
            <select name="consciousOrGA" onChange={handleChange}>
              <option selected disabled>
                Please Select
              </option>
              <option value="Concious">Concious</option>
              <option value="Under GA">Under GA</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.consciousOrGA}
            </span>
          </p>
          <p>
            Stay in the hospital -{" "}
            <select name="stayInHospital" onChange={handleChange}>
              <option selected disabled>
                Please Select
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.stayInHospital}
            </span>
          </p>
          <div className="bulletin">
            <ul>
              <li>
                P4 Start Date &amp; Time -{" "}
                <input
                  type="datetime-local"
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="p4startdateandtime"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.p4startdateandtime}
                </span>
              </li>
              <li>
                ERA:{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="era"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.era}
                </span>
              </li>
              <li>
                P4 Value -{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="p4value"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.p4value}
                </span>
              </li>
              <li>
                ET on Final Day -{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="etonfinalday"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.etonfinalday}
                </span>
                EM Doppler:{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="emdoppler"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.emdoppler}
                </span>
              </li>
              <li>
                NUMBER / DAY / GRADE of Embryos Frozen:{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="embryosFrozen"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.embryosFrozen}
                </span>
              </li>
              <li>
                No of Embryo Transfer: SINGLE OR DOUBLE ET, Reason for SET:{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="reasonforset"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.reasonforset}
                </span>
              </li>
              <li>
                Cryolock to Thaw -{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="cryolocktothaw"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.cryolocktothaw}
                </span>
              </li>
              <li>
                Special Instructions to Embryologist:{" "}
                <select name="specialInstructions" onChange={handleChange}>
                  <option selected disabled>
                    Please Select
                  </option>
                  <option value="LAH">LAH</option>
                  <option value="EG">EG</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.specialInstructions}
                </span>
              </li>
              <li>
                DIFFICULTY ANTICIPATED:{" "}
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="difficultyanticipated"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.difficultyanticipated}
                </span>
              </li>
            </ul>
          </div>
          <p>
            UNDER GA Anesthesia if needed{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="undergaanesthesiaifneeded"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.undergaanesthesiaifneeded}
            </span>
            NPO from{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="npofrom"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.npofrom}
            </span>
          </p>
          <p>
            Frozen Embryo Transfer on{" "}
            <input
              type="datetime-local"
              className={`createTime ${show ? "hide" : "show"}`}
              name="frozenembryotransferon"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.frozenembryotransferon}
            </span>
          </p>
          <p>
            Payment to be done on the day or before transfer{" "}
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="paymenttobedoneonthedayorbeforetransfer"
              onChange={handleChange}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.paymenttobedoneonthedayorbeforetransfer}
            </span>
          </p>
          <table className="table_1" border="1px" cellSpacing="0px">
            <tbody>
              <tr>
                <th>S. No</th>
                <th>Drug Name</th>
                <th>Dose</th>
                <th>Frequency</th>
                <th>Route</th>
                <th>Days</th>
              </tr>
              {[...Array(6).keys()].map((i) => (
                <tr key={i + 1}>
                  <td>{i + 1}</td>
                  <td>Drug {i + 1}</td>
                  <td>
                    <input
                      className={`input ${show ? "hide" : "show"}`}
                      name={`dose${i + 1}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`dose${i + 1}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`input ${show ? "hide" : "show"}`}
                      name={`frequency${i + 1}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`frequency${i + 1}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`input ${show ? "hide" : "show"}`}
                      name={`route${i + 1}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`route${i + 1}`]}
                    </span>
                  </td>
                  <td>
                    <input
                      className={`input ${show ? "hide" : "show"}`}
                      name={`days${i + 1}`}
                      onChange={handleChange}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{formData[`days${i + 1}`]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            POST ET ADJUVANTS: Inj.{" "}
            <select name="postetadjuvants" onChange={handleChange}>
              <option selected disabled>
                Please Select
              </option>
              <option value="LMWH">LMWH</option>
              <option value="IL">IL</option>
              <option value="BG">BG</option>
              <option value="HCQ">HCQ</option>
              <option value="Wysolone">Wysolone</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.postetadjuvants}
            </span>
          </p>
          <br />
          <br />
          <p>
            If in case of fever or cold or unable to come to report 5-6 hours
            before embryo
            <br />
            transfer Please make sure you are with your full bladder(make sure
            you drink
            <br />
            enough water to fill your bladder moderately do not empty your
            bladder prior to
            <br />
            the embryo transfer procedure unless otherwise specified. As embryo
            transfer
            <br />
            is done with USG guidance.
          </p>
        </div>
        <p style={{ fontWeight: "600" }}>
          NEXT APPOINTMENT -{" "}
          <input
            name="nextappointment"
            onChange={handleChange}
            type="datetime-local"
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>

      <div id="etReportGenerate">
        <div id="etReportGenerateWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          {/* <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>Male : </h4>
          </div> */}
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("Plan FET on :", formData.planfeton?.split("-").reverse().join("-"))}
            {renderReportfield("Admission on :", formData.admissionon?.split("-").reverse().join("-"))}
            {renderReportfield("Condition :", formData.consciousOrGA)}
            {renderReportfield(
              "Stay in the hospital :",
              formData.stayInHospital
            )}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield(
              " P4 Start Date & Time :",
              `${formData?.p4startdateandtime?.split("T")[0]?.split("-").reverse().join("-")} ${
                formData?.p4startdateandtime?.split("T")[1]
              }`
            )}
            {renderReportfield("ERA :", formData.era)}
            {renderReportfield("P4 Value :", formData.p4value)}
            {renderReportfield("ET on Final Day :", formData.etonfinalday)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("EM Doppler :", formData.emdoppler)}
            {renderReportfield(
              "NUMBER / DAY / GRADE of Embryos Frozen :",
              formData.embryosFrozen
            )}
          </div>

          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("Cryolock to Thaw :", formData.cryolocktothaw)}
            {renderReportfield(
              "Special Instructions to Embryologist :",
              formData.specialInstructions
            )}
            {renderReportfield(
              "DIFFICULTY ANTICIPATED :",
              formData.difficultyanticipated
            )}
          </div>
          <div style={{ display: "flex" }}>
            {renderReportfield(
              "Frozen Embryo Transfer On :",
              `${formData?.frozenembryotransferon?.split("T")[0]} ${
                formData?.frozenembryotransferon?.split("T")[1]
              }`
            )}
            {renderReportfield(
              "DIFFICULTY ANTICIPATED :",
              formData.difficultyanticipated
            )}
            {renderReportfield(
              "Payment :",
              formData.paymenttobedoneonthedayorbeforetransfer
            )}
          </div>
          <div>
            <table>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "Drug Name",
                    "Dose",
                    "Frequency",
                    "Route",
                    "Days",
                  ].map((ele, ind) => {
                    return renderTableTH(ele);
                  })}
                </tr>
              </thead>
              <tbody>
                {[...Array(6)].map((_, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ind + 1)}
                      {renderTableTD(`Drug ${ind + 1}`)}
                      {["dose", "frequency", "route", "days"].map(
                        (ele, innerind) =>
                          renderTableTD(formData[`${ele}${ind + 1}`])
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex" }}>
            {renderReportfield(
              "POST ET ADJUVANTS Inj. :",
              formData.postetadjuvants
            )}
          </div>
          <div>
            {renderReportfield(`If in case of fever or cold or unable to come to report 5-6 hours before embryo
transfer Please make sure you are with your full bladder(make sure you drink
enough water to fill your bladder moderately do not empty your bladder prior to
the embryo transfer procedure unless otherwise specified. As embryo transfer
is done with USG guidance.`)}
          </div>
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
